export const theme = {
  fonts: {
    montserrat: "'Montserrat', sans-serif",
    cardo: "'Cardo', serif",
  },
  backgroundColor: {
    dark: "#0a0b0d",
    light: "#ffffff",
    lightGray: "#f8f9fa",
    orange: "#ff6b35",
    darkGray: "#111",
    gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
    gradientOrange: "linear-gradient(135deg, #ff6b35 0%, #f7931e 100%)",
    cardBg: "#ffffff",
  },
  color: {
    dark: "#0a0b0d",
    darkGray: "#1a1d2e",
    lightGray: "#6c757d",
    light: "#fff",
    secondaryLight: "#f8f9fa",
    tertiaryLight: "#e9ecef",
    link: "#667eea",
    accent: "#ff6b35",
    text: "#2d3748",
  },
  shadows: {
    small: "0 2px 8px rgba(0, 0, 0, 0.08)",
    medium: "0 4px 16px rgba(0, 0, 0, 0.1)",
    large: "0 8px 32px rgba(0, 0, 0, 0.12)",
    hover: "0 12px 48px rgba(0, 0, 0, 0.18)",
    card: "0 4px 20px rgba(102, 126, 234, 0.1)",
  },
  CTA: {
    primary: "#ff6b35",
    secondary: "#667eea",
  },
  breakpoints: {
    lg: "64rem",
    md: "58.125rem",
    sm: "48rem",
    xs: "31.25rem",
  },
};
